import React from 'react';
import { ImportFields } from 'components/import/ImportTypes';
import ImportWizard from 'components/import/ImportWizard';

const ProductImport: React.FC = () => {

    // Define the import fields
    const importFields: ImportFields = {
        baseFields: [
            {
                product: [
                    { value: 'name', name: 'product.name', required: true },
                    { value: 'number', name: 'product.number' },
                    { value: 'description', name: 'product.description' },
                    { value: 'unit', name: 'product.unit' },
                    { value: 'sale_price', name: 'product.sale_price' },
                    { value: 'vat_rate', name: 'product.vat_rate', description: 'product.vat_rate_hint' },
                    { value: 'ledger_account', name: 'product.ledger_account' },
                    { value: 'category', name: 'product.category' },
                    { value: 'is_active', name: 'product.is_active' },
                    { value: 'reference', name: 'product.reference' },
                ]
            }
        ]
    };

    return (
        <ImportWizard
            apiObject='product'
            closeUrl='products'
            importFields={importFields}
        />
    );
};

export default ProductImport;